"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpResponse = void 0;
/**
 * An HTTP response.
 */
class HttpResponse {
    /**
     * Create a JSON HTTP response.
     *
     * @param parsedBody The parsed body of the response.
     * @param statusCode The status code. Default id 200.
     * @param headers Extra headers. The Content-Type headers are added automatically.
     */
    static json(parsedBody, statusCode = 200, headers = []) {
        return {
            headers: [["content-type", "application/json"], ...headers],
            statusCode,
            body: JSON.stringify(parsedBody),
            parsedBody,
        };
    }
    /**
     * The response headers.
     */
    headers;
    /**
     * The HTTP status code.
     */
    statusCode;
    /**
     * The Raw response body if available
     */
    body;
    /**
     * The Parsed response body (e.g. JSON) if available.
     */
    parsedBody;
    constructor(httpResponse) {
        this.headers = httpResponse.headers;
        this.statusCode = httpResponse.statusCode;
        if (httpResponse.body)
            this.body = httpResponse.body;
        if (httpResponse.parsedBody)
            this.parsedBody = httpResponse.parsedBody;
    }
}
exports.HttpResponse = HttpResponse;
//# sourceMappingURL=http-response.js.map